import { DataState, INIT_DATA_STATE } from './state';
import { Actions, ActionTypes } from './actions';

export function dataReducer(state = INIT_DATA_STATE, action: Actions): DataState {
  switch (action.type) {
    case ActionTypes.SIREN_RESPONSE: {
      return {
        ...state,
        responses: {
          ...state.responses,
          [action.payload.id]: action.payload.response
        }
      }
    }
    case ActionTypes.RESET_ALL_DATA: {
      return {
        responses: { }
      }
    }
    case ActionTypes.RESET_DATA: {
      return { responses: { 'rel/authenticationResult': state.responses['rel/authenticationResult']}}
    }
    default: return state;
  }
}
